export class InvestimentoCreditoFinanceiroVO {

  investimentoPdi: number;
  creditoGerado: number;
  
}
